import { Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimezoneInterceptorService {

  constructor(private injector: Injector) { }

  intercept(req, next) {
    // let timezone = new Date().getTimezoneOffset() / -60
    const timezoneReq = req.clone({
      setHeaders: {
        timezone: `UTC+07:00`
      }
    });
    return next.handle(timezoneReq);
  }
}
